import { Typography } from '@mui/material';
import { DisplayName } from './DisplayName';

export const ItemContact = ({ row }) => {
    if (row.contact?.status === 1)
        return (
            <Typography>
                <DisplayName contact={row.contact} />
            </Typography>
        );

    return <Typography>{row.contact?.display_name}</Typography>;
};
